import React, {Component} from 'react'
import PropTypes from "prop-types";

class RecommendedTreatments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry:this.props.entry
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    componentDidMount() {
    }

    render() {
        let {t} = this.props

        let {entry}=this.state
        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow-high'}>
                    <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Additional_tests')}</label>
                        <textarea  className={'info-inputBoxStyle-visitSummary boxMargin'} defaultValue={entry.Additional_tests} maxLength={"5000"}
                                   onChange={(event) => this.props.onValueChange("Additional_tests", event.target.value)}/>
                    </div>
                </div>
                <div className={'patientsFormRow-high'}>
                    <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Recommended_medications')}</label>
                        <textarea  className={'info-inputBoxStyle-visitSummary boxMargin'} defaultValue={entry.Recommended_medications} maxLength={"5000"}
                                   onChange={(event) => this.props.onValueChange("Recommended_medications", event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow-high'}>
                    <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Recommended_invasive_treatment')}</label>
                        <textarea  className={'info-inputBoxStyle-visitSummary boxMargin'} defaultValue={entry.Recommended_invasive_treatment} maxLength={"5000"}
                                   onChange={(event) => this.props.onValueChange("Recommended_invasive_treatment", event.target.value)}/>
                    </div>
                </div>

                <div className={'patientsFormRow-high'}>
                    <div className={'inputSlotsDoc-full'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Other_treatment')}</label>
                        <textarea  className={'info-inputBoxStyle-visitSummary boxMargin'} defaultValue={entry.Other_treatment} maxLength={"5000"}
                                   onChange={(event) => this.props.onValueChange("Other_treatment", event.target.value)}/>
                    </div>
                </div>

            </div>

        )
    }
}

RecommendedTreatments.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    onClickCheckboxes:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    checkboxes: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default RecommendedTreatments;
